module.exports = "/images/icon-jpg.svg?8cfce9c22802e3dd2093dea8447726e5";